import { configureStore } from '@reduxjs/toolkit';
import { setUser } from '../stores/user/user.store';
import rootReducer from './rootReducer';
import reduxManager from '../../utils/ReduxManager';
import { updateLanguage } from '../stores/language/language.store';
import axiosInstance from '../../initializers/axios';
import { ApiConstants } from '../../constants/ApiConstants';
import { SetEnums } from '../stores/allEnums/allEnums.store';

const initStore = (currentUser: any, language?: string) => {
  const appStore = configureStore({
    reducer: rootReducer,
  });
  reduxManager.dispatch = appStore.dispatch;
  reduxManager.store = appStore;
  if (currentUser) {
    appStore.dispatch(setUser(currentUser));
    axiosInstance
      .get(ApiConstants.enum.allEnums)
      .then((response) => {
        appStore.dispatch(SetEnums(response.data));
      })
      .catch((error) => {
        console.error('Failed to load enums:', error);
        appStore.dispatch(SetEnums({}));
      });
  }
  if (language) {
    appStore.dispatch(updateLanguage(language));
  }

  return appStore;
};

export default initStore;
